module.exports = __webpack_public_path__ + "static/media/logo.419f5832.svg";